const Card = {
  defaultProps: {
    p: 'xs',
    radius: 6,
    withBorder: false,
  },
  styles: (theme, _params) => ({
    root: {
      backgroundColor: theme.colors.accentSubtle[0],
    },
  }),
};

export default Card;
